import styled from '@emotion/styled'

export const Name = styled.div`
  color: #007aff;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Roboto;
  font-size: 15.756px;
  font-style: normal;
  font-weight: 400;
  line-height: 143%; /* 22.532px */
  letter-spacing: 0.133px;
`
